import React, { FC, useContext } from 'react'
import { DESCRIPTION_GENERAL_NAME, GUID_GENERAL_NAME } from '../Constants/FieldNames'
import CLanguageHandler from '../../../../../../NonReact/Languages/LanguageHandler'
import LanguageContext from '../../../../../../React/Common/Contexts/LanguageContext'
import FormRow from '../../../../../../React/Common/Components/FormRow'
import { ValidationErrors } from '../../../../../../React/Common/Components/ValidationErrors/ValidationErrors'
import { CRMModal } from '../../../../../../../i18n'
import { OutlinedTextInput } from '../../../../Atoms/Inputs/OutlinedTextInput'
import { CRMServerResponse } from '../Types/Types'
import { isVarNotEmpty } from '../../../../../../NonReact/utils/GlobalFunctions'
import { OutlineTextAreaMulti } from '../../../../Atoms/Inputs/OutlineTextAreaMulti'

type Props = {
    viewOnly?: boolean
    currentCRMConfiguration?: Nullable<CRMServerResponse>
}

const CRMDetailsTab: FC<Props> = ({ viewOnly, currentCRMConfiguration }: Props) => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    return (
        <div className='tab-area'>
            <FormRow>
                <ValidationErrors name={DESCRIPTION_GENERAL_NAME}>
                    <OutlinedTextInput
                        labelLeft={language.get(CRMModal.CRMDetailsDescriptionLabel)}
                        inputName={DESCRIPTION_GENERAL_NAME}
                        rules={{
                            required: language.get(CRMModal.CRMValidationDescriptionLabel)
                        }}
                        disabled={viewOnly}
                    />
                </ValidationErrors>
            </FormRow>
            <FormRow>
                <ValidationErrors name={GUID_GENERAL_NAME}>
                    <OutlinedTextInput
                        placeholder={language.get(CRMModal.CRMDetailsIDLabelPlaceholder)}
                        labelLeft={language.get(CRMModal.CRMGeneralIDLabel)}
                        inputName={GUID_GENERAL_NAME}
                        disabled={viewOnly || isVarNotEmpty(currentCRMConfiguration)}
                    />
                </ValidationErrors>
            </FormRow>
        </div>
    )
}

export default CRMDetailsTab
